import type { ReactNode } from "react";
import { cn } from "cn";

export interface FilterPanelBodyProps {
    children: ReactNode;
    className?: string;
}

export function FilterPanelBody({ children, className }: FilterPanelBodyProps) {
    return <div className={cn("flex min-h-0 flex-col gap-3", className)}>{children}</div>;
}
